import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GetVaultsResponse } from '../models/vault.model';
import { WalletsResponse } from '../models/wallet.model';
import { environment } from '@/environments/environment';

/**
 * All HTTP calls in this service return the standard
 * `ApiResponse<T>` envelope.
 */
@Injectable({
  providedIn: 'root',
})
export class SharedVaultService {
  private readonly apiUrl = environment.assetManagementApiUrl;
  constructor(private http: HttpClient) {}

  getVaults(
    page: number = 1,
    limit: number = 10
  ): Observable<GetVaultsResponse> {
    return this.http.get<GetVaultsResponse>(`${this.apiUrl}/api/v1/vault`, {
      params: { page: page.toString(), limit: limit.toString() },
    });
  }

  getWallets(
    vaultId: string,
    page: number = 1,
    limit: number = 10
  ): Observable<WalletsResponse> {
    return this.http.get<WalletsResponse>(
      `${this.apiUrl}/api/v1/vault/${vaultId}/wallets`,
      {
        params: { page: page.toString(), limit: limit.toString() },
      }
    );
  }
}
